import { render, staticRenderFns } from "./TutorCardSign.vue?vue&type=template&id=565ff566&scoped=true&"
import script from "./TutorCardSign.vue?vue&type=script&lang=js&"
export * from "./TutorCardSign.vue?vue&type=script&lang=js&"
import style0 from "./TutorCardSign.vue?vue&type=style&index=0&id=565ff566&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "565ff566",
  null
  
)

export default component.exports